import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-4 col-xxl-4 col-sm-4 mb-10" }
const _hoisted_2 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "text-black fw-bold mb-10" }, "Mot de passe", -1)
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Ancien mot de passe ", -1)
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Nouveau mot de passe ", -1)
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Confirmer le nouveau mot de passe ", -1)
const _hoisted_14 = { class: "col-md-12" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", {
  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
  type: "submit"
}, " Modifier ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Form, {
          ref: "userPassForm",
          onSubmit: _ctx.editUserPass,
          "validation-schema": _ctx.userPassSchema,
          "initial-values": _ctx.userPassForm
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_Field, {
                  name: "password",
                  type: "password",
                  class: "form-control shadow-none fs-md-15 text-black"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "password",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Field, {
                  name: "newPassword",
                  type: "password",
                  class: "form-control shadow-none fs-md-15 text-black"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "newPassword",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_Field, {
                  name: "confirmNewPassword",
                  type: "password",
                  class: "form-control shadow-none fs-md-15 text-black"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "confirmNewPassword",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_router_link, {
                  to: "/tableau_bord",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_17,
                    _hoisted_18,
                    _createTextVNode("Annuler")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema", "initial-values"])
      ])
    ])
  ]))
}